import type { PatientGroup } from "./patient-group";

// TES-941/943 — readable names for the forms, in place of the codes (F-01,
// F-02, …) the clinician would otherwise have to know. Emelie's list,
// verbatim:
//   "F-01: Inledande frågor"
//   "F-02: Medicinsk hälsodeklaration – nybehandling"
//   "F-02B: Medicinsk hälsodeklaration – receptövertag"
//   "F-07: Läkemedel och behandlingsunderlag"
//   "F-04: Veckoincheckning"
//   "Månadsformuläret: Månadsincheckning"
//
// Keyed by the stored `templateKey`. F-02 and F-02B are ONE template
// (`intake`) rendered in two variants (TES-759), so its name depends on the
// patient's journey rather than on the key alone.
export const FORM_DISPLAY_NAMES = {
  f01: "Inledande frågor",
  intake: "Medicinsk hälsodeklaration – nybehandling",
  prescription_transfer: "Läkemedel och behandlingsunderlag",
  weekly_checkin: "Veckoincheckning",
  milestone: "Månadsincheckning",
} as const satisfies Record<string, string>;

export const INTAKE_TRANSFER_DISPLAY_NAME =
  "Medicinsk hälsodeklaration – receptövertag";

// The readable name for a submission's form. Unknown keys fall back to the
// key itself, so a new template shows up as something rather than nothing.
export function formDisplayName(
  templateKey: string,
  patientGroup?: PatientGroup | null,
): string {
  if (templateKey === "intake" && patientGroup === "PRESCRIPTION_TRANSFER") {
    return INTAKE_TRANSFER_DISPLAY_NAME;
  }
  return (
    (FORM_DISPLAY_NAMES as Record<string, string>)[templateKey] ?? templateKey
  );
}
